import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import ReactSelect from 'react-select';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import InputMask from 'react-input-mask';
import { useNavigate, useParams } from 'react-router-dom';

const Update = () => {

    const { id } = useParams();
    const navigate = useNavigate();

    const { readDataGet: getConsumerstatus } = useEntityCrud('Info/GetServiceConsumerstatus');
    const { addData: updateServiceConsumers } = useEntityCrud('ServiceConsumer/UpdateServiceConsumer');
    const { addData: changeStatus } = useEntityCrud('ServiceConsumer/changeServiceConsumer');
    const { readData: getServiceConsumer } = useEntityCrud('ServiceConsumer/GetServiceConsumer');
    const [statusLevel, setStatusLevel] = useState(0);


    const [allStatus, setAllStatus] = useState([]);
    const [preparationTime, setPreparationTime] = useState('');
    const [statusId, setStatusId] = useState();

    const [userDetails, setUserDetails] = useState({
        delivername: '',
        deliverlastname: '',
        delivermobile: '',
        nationalCode: '',
        delivervehicle1: '',
        delivervehicle2: '',
        deliverPreparationTime: ''
    });

    const [pelak, setPelak] = useState({
        two: "",
        three: "",
        iran: ""
    })

    useEffect(() => {
        getConsumerstatus().then(({ data }) => {
            if (data.status) {
                setAllStatus(data.result
                    .map(item => ({ value: item.id, label: item.title }))
                );
            }
        });

        const postedData = {
            serviceConsumerId: id,
            additionalInfo: []
        };
        getServiceConsumer(postedData).then(({ data }) => {
            if (data.status) {
                setStatusLevel(data.result.status);
            }
        });

    }, [])


    const updateServiceConsuer = () => {
        debugger
        const postedData = {
            "offset": 0,
            "limit": 0,
            "personId": 0,
            "registerDate": 0,
            "subServiceId": [
                0
            ],
            "serviceConsumerId": 0,
            "status": 0,
            "businessId": 0,
            "totalAmount": 0,
            "totalDiscount": 0,
            "totalPay": 0,
            "addressId": 0,
            "serviceConsumerId": id,
            "delivername": userDetails.delivername,
            "deliverlastname": userDetails.deliverlastname,
            "delivermobile": (userDetails.delivermobile).replaceAll("-", ""),
            "delivervehicle": `${userDetails.delivervehicle1}${userDetails.delivervehicle2}`,
            "deliverPreparationTime": userDetails.deliverPreparationTime,
            "status": statusId,
            "additionalInfo": [
                {
                    "key": "",
                    "value": ""
                }
            ]
        };

        updateServiceConsumers(postedData).then(({ data }) => {
            debugger
            if (data.status) {
                toast.success('  اطلاعات با موفقیت ایجاد شد');
                navigate("/service-consumer");
            } else {
                toast.error(data.message);

            }
        })
    }

    const handleStatusType = (thiStatus) => {
        debugger
        const postedData = {
            "offset": 0,
            "limit": 0,
            "serviceConsumerId": id,
            preparationTime,
            "status": thiStatus
        };

        changeStatus(postedData).then(({ data }) => {
            debugger
            if (data.status) {

                toast.success(' وضعیت با موفقیت ثبت شد. ');

                if (thiStatus !== 4) {
                    navigate("/service-consumer");
                }

            } else {
                toast.error(data.message);

            }
        })
    }

    function handleChangeTwo(e) {
        if (e.target.value.match("^[1-9]*$") != null) {
            setPelak(form => ({ ...form, two: e.target.value.slice(0, 2) }))
        }
    }

    function handleChangeThree(e) {
        if (e.target.value.match("^[1-9]*$") != null) {
            setPelak(form => ({ ...form, three: e.target.value.slice(0, 3) }))
        }
    }

    function handleChangeIran(e) {
        setPelak(form => ({ ...form, iran: e.target.value.slice(0, 1) }))
    }

    return (
        <div className="card">
            <div className="card-body">
                <div className="wizard">
                    <div className="content clearfix">

                        <section className="body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div class="alert alert-danger" role="alert">
                                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-hidden="true">×</button>
                                        <i class="fa fa-bell-o me-2" aria-hidden="true"></i>
                                        کاربر گرامی با انتخاب هر یک از موارد لیست ثبت وضعیت صورت خواهد گرفت.
                                    </div>
                                    <div className='row mb-4'>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>    وضعیت </label>
                                                <ReactSelect
                                                    options={allStatus.filter((item , i) => {
                                                        return i > statusLevel
                                                    })} noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید"
                                                    value={allStatus.filter(item => item.value == statusId)}
                                                    onChange={e => {
                                                        setStatusId(e.value)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        {statusId == 3 ? <div className="col-md-3">
                                            <div className="form-group">
                                                <label>مدت زمان تحویل (دقیقه)</label>
                                                <input type="number" min={0} maxLength={4} className="form-control" value={preparationTime} onChange={e => setPreparationTime(e.target.value)} />
                                            </div>
                                        </div> : ''}
                                    </div>
                                    <div className="row">
                                        <div className="col-md-2">
                                            <button className="btn btn-success btn-block btn-without-label" onClick={handleStatusType} > ثبت اطلاعات </button>
                                        </div>
                                    </div>

                                    {statusId === 4 && <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>نام پیک </label>
                                                <input type="text" className="form-control" value={userDetails.delivername} onChange={e => setUserDetails({ ...userDetails, delivername: e.target.value })} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>نام خانوادگی پیک  </label>
                                                <input type="text" className="form-control" value={userDetails.deliverlastname} onChange={e => setUserDetails({ ...userDetails, deliverlastname: e.target.value })} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>شماره همراه پیک</label>
                                                <InputMask mask="9999-9999999" type="tel" className="form-control ltr-input" value={userDetails.delivermobile} onChange={e => setUserDetails({ ...userDetails, delivermobile: e.target.value })} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>شماره پلاک</label>
                                                <InputMask mask="999" className="form-control ltr-input mb-1" value={userDetails.delivervehicle1} onChange={e => setUserDetails({ ...userDetails, delivervehicle1: e.target.value })} style={{ width: "40%", float: "left" }} />
                                                <InputMask mask="99999" className="form-control ltr-input" value={userDetails.delivervehicle2} onChange={e => setUserDetails({ ...userDetails, delivervehicle2: e.target.value })} style={{ width: "70%", float: "left" }} />

                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>مدت زمان تحویل (دقیقه)</label>
                                                <input type="number" min={0} maxLength={4} className="form-control" value={userDetails.deliverPreparationTime} onChange={e => setUserDetails({ ...userDetails, deliverPreparationTime: e.target.value })} />
                                            </div>
                                        </div>
                                        {/*      <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="companyId"> شماره پلاک  </label>
                                                <div className=" d-flex align-items-end justyify-content-center" dir="ltr">

                                                    <input
                                                        placeholder={"77"}
                                                        type="text"
                                                        value={pelak.two}
                                                        onChange={handleChangeTwo}
                                                        style={{ width: "15%" }}
                                                        required
                                                        minLength={2}
                                                        className="form-control"
                                                    />

                                                    <div style={{ width: "15%", margin: "0 2%" }}>
                                                        <input
                                                            placeholder={"ج"}
                                                            type="text"
                                                            value={pelak.iran}
                                                            onChange={handleChangeIran}
                                                            required
                                                            minLength={1}
                                                            style={{ width: "100%" }}
                                                            className="form-control" />
                                                    </div>

                                                    <input
                                                        placeholder={"777"}
                                                        style={{ width: "25%" }}
                                                        type="text"
                                                        required
                                                        minLength={3}
                                                        value={pelak.three}
                                                        className="form-control"
                                                        onChange={handleChangeThree} />

                                                </div>
                                            </div>
                                        </div> */}



                                    </div>
                                    }


                                    {statusId === 4 && <div className='row'>
                                        <div className="col-md-2">
                                            <button className="btn btn-success btn-block btn-without-label" onClick={() => updateServiceConsuer()} > ثبت اطلاعات </button>
                                        </div>
                                    </div>
                                    }

                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>
    );

}

export default Update;